export default __webpack_public_path__ + "media/brand.d1ea0444.png";